(function (app) {

    app.provider("financeApi",
        [
            function () {
                this.$get = [
                    "complianceHubApiGateway", function (complianceHubApiGateway) {
                        var service = [];

                        //GETs
                        service.get = function (transactionId) {
                            return complianceHubApiGateway.get("/Transactions/" + transactionId + "/Finances");
                        };

                        service.getOtherFinanceByType = function (financeId, type) {
                            return complianceHubApiGateway.get("/Finances/" + financeId + "/OtherFinances/Type/" + type);
                        };

                        //PUTs
                        service.updateMonthlyIncomes = function (financeId, finance) {
                            return complianceHubApiGateway.put("/Finances/" + financeId + "/MonthlyIncomes", finance);
                        };

                        service.updateMonthlyExpenses = function (financeId, finance) {
                            return complianceHubApiGateway.put("/Finances/" + financeId + "/MonthlyExpenses", finance);
                        };

                        service.updateAssets = function (financeId, finance) {
                            return complianceHubApiGateway.put("/Finances/" + financeId + "/Assets", finance);
                        };

                        service.updateLiabilities = function (financeId, finance) {
                            return complianceHubApiGateway.put("/Finances/" + financeId + "/Liabilities", finance);
                        };

                        service.updateOtherFinance = function (financeId, otherFinanceId, otherFinance) {
                            return complianceHubApiGateway.put("/Finances/" + financeId + "/OtherFinances/" + otherFinanceId, otherFinance);
                        };

                        //POSTs
                        service.add = function (transactionId, finance) {
                            return complianceHubApiGateway.post("/Transactions/" + transactionId + "/Finances", finance);
                        };

                        service.addOtherFinance = function (financeId, otherFinance) {
                            return complianceHubApiGateway.post("/Finances/" + financeId + "/OtherFinances", otherFinance);
                        };

                        //DELETEs
                        service.deleteOtherFinance = function (financeId, otherFinanceId) {
                            return complianceHubApiGateway.delete("/Finances/" + financeId + "/OtherFinances/" + otherFinanceId);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line